<template>
  <dialogTemplate
    :widthDialog="'450px'"
    :classDialog="'refuse-dialog'"
    :modalAppendToBody="true"
    :appendToBody="true"
    :openDialog="isOpen"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <div class="flex-row flex__left">
        <h3 class="dialogTitle">Chỉnh sửa phụ lục</h3>
      </div>
      <el-form
        ref="form"
        class="margin-bottom-10"
      >
        <el-form-item
          prop="value"
          :label="'Nhập phụ lục'"
        >
          <el-input
            type="textarea"
            v-model="form.value"
            placeholder="-"
            resize="none"
            :rows="5"
          />
        </el-form-item>
      </el-form>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button
          class="dialogBtnPrimary"
          @click="save"
        >
          <i class="fas fa-share"></i>&nbsp;
          Xác nhận
        </el-button>
        <el-button
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >
          <i class="fas fa-times"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
  export default {
    name: 'edit-phu-luc-dialog',
    props: ["isOpen"],
    components: {
      dialogTemplate: () => import('../../common/custom-dialog.vue')
    },
    data() {
      return {
        form: {
          value: null,
        }
      }
    },
    methods: {
      save() {
        this.$emit("valueChanged", {value: this.form.value});
      },
      setValue(value) {
        this.form.value = value;
      }
    }
  }
</script>

<style scoped>
  .icon-alert {
    color: #e54d42;
  }
</style>



// WEBPACK FOOTER //
// src/views/common/noteDocs/edit-phu-luc-dialog.vue